









































import { VideoMarketplace } from '@/models'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { v4 as uuidv4 } from 'uuid'
import { obrigatorio } from '@/shareds/regras-de-form'

@Component
export default class DialogoDeVideoMarketplace extends Vue {
	@Ref() formulario!: HTMLFormElement
	video: VideoMarketplace | null = null
	mostra = false
	editando = false

	obrigatorio = obrigatorio

	mostrar(video: VideoMarketplace | null) {
		if (video) {
			this.editando = true
			this.video = video
		} else {
			this.editando = false
			this.video = {
				id: uuidv4(),
				nome: '',
				url: '',
			}
		}
		this.mostra = true
	}

	confirmar() {
		if(!this.formulario.validate()) return
		this.$emit('atualizarVideos', this.video)
		this.fecharDialogo()
	}

	editar() {
		if(!this.formulario.validate()) return
		this.$emit('salvarVideo', this.video)
		this.fecharDialogo()
	}

	fecharDialogo() {
		this.mostra = false
		this.video = null
	}
}

